import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  SimpleChange,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import {
  ContentControlledEditingDirective,
  ContentControlledEditingDirectiveViewModel
} from 'app/js/src/domain/content-control/editing-directive';

@Component({
  selector: "evrideo-content-control-studio-timeline-segment",
  templateUrl: "./content-control-studio-timeline-segment.component.html",
  styleUrl: "./content-control-studio-timeline-segment.component.scss",
})
export class ContentControlStudioTimelineSegmentComponent {
  @Input() segment?: ContentControlledEditingDirectiveViewModel;
  @Input("width") segmentWidth: number;
  @Output("on-drag-in-mark") dragIn = new EventEmitter<Event>();
  @Output("on-drag-out-mark") dragOut = new EventEmitter<Event>();
  @ViewChild("rect") rect: ElementRef<SVGElement>;

  ngAfterViewInit() {
    this.applyStyles();
  }
  ngOnChanges() {
    this.applyStyles();
  }

  applyStyles() {
    if (this.segmentWidth && this.rect) {
      const sw = Math.ceil(Math.abs(this.segmentWidth));
      this.rect.nativeElement.setAttribute("width", sw.toString());
      this.rect.nativeElement.setAttribute("viewBox", `0 0 ${sw} 12`);
      this.rect.nativeElement
        .querySelector("rect")
        .setAttribute("width", sw.toString());
    }
  }
}
